import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthManagementService } from '@core/service/auth-management.service';

@Component({
  selector: 'app-redirect-by-role',
  template: '',
  standalone: true,
})
export class RedirectByRoleComponent implements OnInit {
  constructor(
    private auth: AuthManagementService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.router.navigateByUrl(this.auth.getDefaultRoute(), { replaceUrl: true });
  }
}
